
// import { Modal, Table, message } from 'antd';
import { Button, Col, DatePicker, Form, Input, Modal, Row, Space, Table, message } from 'antd';

import axios from 'axios';
import React, { useEffect, useState } from 'react';
import servicePath from '../config/apiUrl';
import '../static/css/CameraList.css';
const { confirm } = Modal;

function AdlList(props) {

  const [keyword, setKeyword] = useState('')  
  const [list, setList] = useState([])
  const [filterType, setFilterType] = useState('all') // all, paid, gifted
  const [giftModalVisible, setGiftModalVisible] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [giftForm] = Form.useForm()
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
      showSizeChanger: false,
      showTotal: (total) => `共 ${total} 条`,
    },
  });

  // 日志 Modal 状态
  const [logModalVisible, setLogModalVisible] = useState(false)
  const [logLoading, setLogLoading] = useState(false)
  const [logs, setLogs] = useState([])
  const [logUser, setLogUser] = useState(null)

  // 充值记录 Modal 状态
  const [payModalVisible, setPayModalVisible] = useState(false)
  const [payLoading, setPayLoading] = useState(false)
  const [payRecords, setPayRecords] = useState([])
  const [payUser, setPayUser] = useState(null)

  const openPayModal = async (user) => {
    setPayUser(user)
    setPayModalVisible(true)
    setPayLoading(true)
    try {
      const resp = await axios.post(servicePath.getUserPayOrders, { userId: user.id, limit: 50 }, { withCredentials: true })
      if (resp.data.code === 0) {
        setPayRecords(resp.data.data || [])
      } else {
        setPayRecords([])
        message.error(resp.data.message || '获取充值记录失败')
      }
    } catch (err) {
      console.error('获取充值记录错误', err)
      setPayRecords([])
      message.error('获取充值记录失败')
    } finally {
      setPayLoading(false)
    }
  }

  const closePayModal = () => {
    setPayModalVisible(false)
    setPayRecords([])
    setPayUser(null)
  }

  const openLogModal = async (user) => {
    setLogUser(user)
    setLogModalVisible(true)
    setLogLoading(true)
    try {
      const resp = await axios.post(servicePath.getUserVipGiftLog, { userId: user.id, limit: 50 }, { withCredentials: true })
      if (resp.data.code === 0) {
        setLogs(resp.data.data || [])
      } else {
        setLogs([])
        message.error(resp.data.message || '获取日志失败')
      }
    } catch (err) {
      console.error('获取日志错误', err)
      setLogs([])
      message.error('获取日志失败')
    } finally {
      setLogLoading(false)
    }
  }

  const closeLogModal = () => {
    setLogModalVisible(false)
    setLogs([])
    setLogUser(null)
  }
  //得到用户列表
  const getList = (currentPage, pageSize) => {
    const key = 'getList';

    message.loading({ content: '加载数据...', key });
    axios({
      method: 'post',
      url: servicePath.getUserList,
      withCredentials: true,
      data: {
        keyword: keyword, 
        filterType: filterType,
        page: currentPage ? currentPage : (tableParams.pagination?.current || 1),
        pageSize: pageSize || tableParams.pagination?.pageSize,
      },
      header: { 'Access-Control-Allow-Origin': '*' }
    }).then(
      res => {
        console.log("res", res)
        if (res.data.code == 1) {
          let respData = res.data?.data || {}
          setList(respData?.list || [])

          setTableParams({
            ...tableParams,
            pagination: {
              ...tableParams.pagination,
              current: respData?.currentPage || 1,
              pageSize: tableParams.pagination?.pageSize || 20,
              total: respData?.totalCount || 0,
            },
          });
          message.success({ content: '加载数据成功！', key, duration: 2 });
        } else {
          setList([])
          message.error({ content: '加载数据失败！', key, duration: 2 });
        }
      }
    ).catch((res) => {
      console.log("err", res)
      setList([])
      message.error({ content: '加载数据失败！', key, duration: 2 });
    })
  }
  useEffect(() => {
    getList(1)
  }, [keyword, filterType])

  const [form] = Form.useForm();

  const onFinish = (values) => {
    setKeyword(values?.keyword || '')
  };

  const onReset = () => {
    form.resetFields();
    setKeyword('');
  };
  const handleTableChange = (
    pagination
  ) => {
    setTableParams({
      pagination
    });
    getList(pagination.current, pagination.pageSize)
  };

  // 打开赠予弹窗
  const openGiftModal = (user) => {
    console.log('打开赠予弹窗，用户信息:', user)
    setSelectedUser(user)
    setGiftModalVisible(true)
    setTimeout(() => giftForm.resetFields(), 0)
    console.log('弹窗状态已设置为可见')
  }

  // 关闭赠予弹窗
  const closeGiftModal = () => {
    console.log('关闭赠予弹窗')
    setGiftModalVisible(false)
    setSelectedUser(null)
    giftForm.resetFields()
  }

  // 执行赠予操作
  const handleGiftSubmit = async (values) => {
    console.log('开始执行赠予操作，表单值:', values)
    console.log('选中的用户:', selectedUser)
    
    if (!selectedUser) {
      console.error('没有选中的用户')
      return
    }
    
    try {
      console.log('准备发送API请求到:', servicePath.giftVipMembership)
      const requestData = {
        userId: selectedUser.id,
        giftedValidUntil: values.giftedValidUntil.format('YYYY-MM-DD HH:mm:ss')
      }
      console.log('请求数据:', requestData)
      
      const response = await axios({
        method: 'post',
        url: servicePath.giftVipMembership,
        withCredentials: true,
        data: requestData
      })

      console.log('API响应:', response.data)
      
      if (response.data.code === 0) {
        console.log('赠予会员成功')
        message.success('赠予会员成功')
        closeGiftModal()
        getList(tableParams.pagination.current, tableParams.pagination.pageSize)
      } else {
        console.error('赠予失败，响应码:', response.data.code)
        message.error(response.data.message || '赠予失败')
      }
    } catch (error) {
      console.error('赠予会员失败:', error)
      console.error('错误详情:', error.response?.data || error.message)
      message.error('赠予会员失败')
    }
  }

  // 定义列配置
  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: '用户名', dataIndex: 'username', key: 'username' },
    {
      title: '头像',
      dataIndex: 'avatar_url',
      key: 'avatar_url',
      render: avatarUrl => <img style={{ width: '60px', height: 'auto' }} src={servicePath.serverUrl + avatarUrl} alt='用户头像' />
    },
    { title: '创建时间', dataIndex: 'created_at', key: 'created_at' },
    { title: 'VIP有效期', dataIndex: 'vip_validity', key: 'vip_validity', render: (text, record) => (
      <div>
        <span>{text || '-'}</span>
        <Button type="link" onClick={() => openPayModal(record)} style={{ marginLeft: 8 }}>
          查看充值记录
        </Button>
      </div>
    ) },
    { title: '赠予有效期', dataIndex: 'gifted_validity', key: 'gifted_validity' },
    { title: '会员来源', dataIndex: 'vip_source', key: 'vip_source', render: vip_source => {
      if (!vip_source) return '未付费';
      if (vip_source === 'gifted') return '赠予';
      if (vip_source === 'free_trial') return '免费试用';
      return '付费';
    }},
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button type="link" onClick={() => openGiftModal(record)}>
            赠予会员
          </Button>
          {record.gifted_validity ? (
            <Button type="link" danger onClick={() => {
              // 确认取消赠与
              confirm({
                title: '确认取消赠与？',
                content: `将清除用户 ${record.username} 的赠予有效期，是否继续？`,
                onOk: async () => {
                  try {
                    console.log('调用取消赠与接口，userId=', record.id)
                    const resp = await axios.post(servicePath.cancelGiftVipMembership, {
                      userId: record.id,
                      reason: '管理员手动取消'
                    }, { withCredentials: true });
                    console.log('取消赠与响应', resp.data)
                    if (resp.data.code === 0) {
                      message.success('取消赠与成功')
                      getList(tableParams.pagination.current, tableParams.pagination.pageSize)
                    } else {
                      message.error(resp.data.message || '取消赠与失败')
                    }
                  } catch (err) {
                    console.error('取消赠与出错', err)
                    message.error('取消赠与失败')
                  }
                },
              });
            }}>
              取消赠与
            </Button>
          ) : null}
          <Button type="link" onClick={() => openLogModal(record)}>
            查看日志
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        style={{
          maxWidth: '100%',
          marginBottom: '20px'
        }}
      >
        <Row gutter={16}>
          <Col className="gutter-row" span={12}>
            <Form.Item
              name="keyword"
              label="搜索用户"
            >
              <Input placeholder="请输入用户名或ID" />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={6}>
            <Form.Item>
              <Space>
                <Button type="primary" htmlType="submit">
                  搜索
                </Button>
                <Button htmlType="button" onClick={onReset}>
                  重置
                </Button>
              </Space>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={6}>
            <Form.Item label="用户筛选">
              <Space>
                <Button 
                  type={filterType === 'all' ? 'primary' : 'default'} 
                  onClick={() => setFilterType('all')}
                >
                  全部用户
                </Button>
                <Button 
                  type={filterType === 'paid' ? 'primary' : 'default'} 
                  onClick={() => setFilterType('paid')}
                >
                  付费用户
                </Button>
                <Button 
                  type={filterType === 'gifted' ? 'primary' : 'default'} 
                  onClick={() => setFilterType('gifted')}
                >
                  赠予用户
                </Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Table onChange={handleTableChange} pagination={tableParams.pagination} dataSource={list} bordered columns={columns} />

      {/* 赠予会员弹窗 */}
      <Modal
        title="赠予会员"
        visible={giftModalVisible}
        onCancel={closeGiftModal}
        footer={null}
        width={400}
        destroyOnClose
        forceRender
        getContainer={false}
      >
        <Form
          form={giftForm}
          layout="vertical"
          onFinish={handleGiftSubmit}
        >
          <Form.Item
            label="用户信息"
          >
            <Input 
              value={selectedUser ? `${selectedUser.username} (ID: ${selectedUser.id})` : ''} 
              disabled 
            />
          </Form.Item>
          
          <Form.Item
            name="giftedValidUntil"
            label="赠予有效期至"
            rules={[{ required: true, message: '请选择赠予有效期' }]}
          >
            <DatePicker 
              showTime 
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '100%' }}
              placeholder="选择赠予有效期"
            />
          </Form.Item>
          
          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                确认赠予
              </Button>
              <Button onClick={() => {
                console.log('取消按钮被点击')
                closeGiftModal()
              }}>
                取消
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>

      {/* 日志 Modal */}
      <Modal
        title={logUser ? `用户 ${logUser.username} 的赠予日志` : '赠予日志'}
        visible={logModalVisible}
        onCancel={closeLogModal}
        footer={null}
        width={800}
        getContainer={false}
        destroyOnClose
      >
        <Table
          dataSource={logs}
          loading={logLoading}
          rowKey="id"
          pagination={false}
          columns={[
            { title: 'ID', dataIndex: 'id', key: 'id' },
            { title: '操作', dataIndex: 'action', key: 'action', render: a => a === 'grant' ? '赠予' : '取消' },
            { title: '操作人', dataIndex: 'operator_id', key: 'operator_id' },
            { title: '旧值', dataIndex: 'old_value', key: 'old_value' },
            { title: '新值', dataIndex: 'new_value', key: 'new_value' },
            { title: '原因', dataIndex: 'reason', key: 'reason' },
            { title: '时间', dataIndex: 'created_at', key: 'created_at' },
          ]}
        />
      </Modal>

      {/* 充值记录 Modal */}
      <Modal
        title={payUser ? `用户 ${payUser.username} 的充值记录` : '充值记录'}
        visible={payModalVisible}
        onCancel={closePayModal}
        footer={null}
        width={800}
        getContainer={false}
        destroyOnClose
      >
        <Table
          dataSource={payRecords}
          loading={payLoading}
          rowKey="order_code"
          pagination={false}
          columns={[
            { title: '订单号', dataIndex: 'order_code', key: 'order_code' },
            { title: '套餐名称', dataIndex: 'tc_name', key: 'tc_name' },
            { title: '金额', dataIndex: 'total_amount', key: 'total_amount' },
            { title: '时间', dataIndex: 'created_at', key: 'created_at' },
          ]}
        />
      </Modal>
    </div>
  );

}

export default AdlList